<template>
    <!--<div class="nav flex-column nav-pills me-3" id="v-pills-tab" aria-orientation="vertical" style="width: 16% !important;">
        <template v-for="link in sideMenuItems">
            <router-link :to="{ name: link.routeUrl}"
                         :class="($route.name==link.routeUrl )?'nav-link active':'nav-link'"
                         id="v-pills-home-tab">{{link.displayText}}</router-link>
        </template>
    </div>-->
    <nav id="sidebar" class="sidebar-wrapper">
        <div class="sidebar-content">
            <div class="sidebar-menu">
                <ul v-if="isUserLoggedIn">
                    <!--<li v-for="link in sideMenuItems">

                        <router-link :to="{ name: link.routeUrl}" v-if="link.routeUrl!='home'">
                            <i :class="['link.favIcon '+ link.favIcon]"></i>
                            <span>{{link.displayText}}</span>
                        </router-link>
                        <ul class="dropdownlinks" v-if="$filters.IsNull(link.childern,true,null)!= null && link.childern.length>0 ">

                            <li v-for="childlink in link.childern" class="child-nav">

                                <router-link :to="{ name: childlink.routeUrl}" v-if="$filters.IsNull(childlink,true,null)!=null">
                                    <i class="fa fa-chevron-right"></i>
                                    <span>{{childlink.displayText}}</span>
                                </router-link>
                            </li>
                        </ul>


                        <router-link :to="{ name: 'HomePage'}" v-if="link.routeUrl=='home'">
                            <i :class="['link.favIcon '+ link.favIcon]"></i>
                            <span>{{link.displayText}}</span>
                        </router-link>
                    </li>-->
                    <li>
                        <a class="nav-link" href="javascript:;" @click="goToPortalDashboard">
                            <i class="fas fa-tachometer-alt"></i>
                            <span>Go To Portal</span>                            
                        </a>
                    </li>
                    <li>
                        <a class="login-link" routerlinkactive="active" @click="this.$emit('logout')" ng-reflect-router-link-active="active">
                            <i class="fa fa-sign-out-alt"></i>
                            <span>Logout</span>                            
                        </a>
                    </li>


                </ul>
                <ul v-if="!isUserLoggedIn">
                    <li class="login-link"> <router-link :to="{name:'Login'}">
                       <i class="fas fa-user-circle"></i>{{$t('StoreFront.Login')}}</router-link>
                    </li>
                    <li>
                        <router-link :to="{name:'SignupPage'}" @click="OpenRightMenu" class="top-btn">
                            <i class="fas fa-user-circle"></i> {{$t('StoreFront.Sign Up')}}
                        </router-link>
                    </li>
                </ul>
            </div>

        </div>
    </nav>
</template>

<!--<script>
    export default {
        name: "SideMenu",
        components: {

        },
        data() {

            return {}
        },
        props: ["sideMenuItems"],
        created() {
        }
    }
</script>-->

<script>
    export default {
        name: "SideMenu",
        components: {

        },
        data() {

            return {
                companyLogo: '',
            }
        },
        methods: {
            getCompanyLogo() {
                let logoUrl = localStorage.getItem('companyLogo');
                this.companyLogo = (this.$filters.IsNull(logoUrl, 'null') == 'null') ? require('../../../../../../assets/Theme/DefaultTheme/images/default-logo.png') : logoUrl;
            },
        },
        created() {
            this.getCompanyLogo();
        },
        props: ["sideMenuItems"],
        emits: ['logout']
    }
</script>
<style>
    .child-nav a {
        color: #c67e24 !important;
        padding: 8px 30px 8px 44px !important;
    }

    li.child-nav {
        background: #eae7e7;
        color: #c67e24;
    }
</style>